import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/calendar-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 64H352V16C352 7.2 344.8 0 336 0H304C295.2 0 288 7.2 288 16V64H160V16C160 7.2 152.8 0 144 0H112C103.2 0 96 7.2 96 16V64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V112C448 85.5 426.5 64 400 64zM400 160V240H304V160H400zM176 352V272H272V352H176zM272 384V464H176V384H272zM144 352H48V272H144V352zM176 240V160H272V240H176zM304 272H400V352H304V272zM144 160V240H48V160H144zM48 458V384H144V464H54C50.7 464 48 461.3 48 458zM394 464H304V384H400V458C400 461.3 397.3 464 394 464z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/calendar-alt.js
// module id = 8SdQ
// module chunks = 144